import get from 'lodash/get';
import { DirectiveOptions } from 'vue';
import { africaOptions } from '../globals';
import savePage from '../helpers/savePage';

const isEnabled: boolean = get(africaOptions, 'api.data.pdf.enabled') === true;
const pageId: number = parseInt(get(africaOptions, 'page.id') as any, 10);

const onClick = (el: HTMLElement, id: number, isSave: boolean, isHeadless: boolean) => (event: Event): void => {
    event.preventDefault();
    // const targetKarla = document.getElementsByClassName('karlachat--window')[0];
    // if (targetKarla) {
    //     const targetKarlaNode: HTMLElement = targetKarla as HTMLElement;
    //     targetKarlaNode.style.display = 'none';
    //     setTimeout(() => {
    //         targetKarlaNode.style.display = 'block';
    //     }, 100000);
    // }

    savePage(id, isSave, isHeadless);
};

const createDirective = (id: number, isSave: boolean, isHeadless: boolean): DirectiveOptions => {
    if (!isEnabled) {
        return {};
    }
    let callback: any = null;
    return {
        bind(el: HTMLElement, binding: any): void {
            if (binding.value && binding.value.id) {
                id = binding.value.id;
            }
            callback = onClick(el, id, isSave, isHeadless);
            el.addEventListener('click', callback);
        },
        unbind(el: HTMLElement): void {
            el.removeEventListener('click', callback);
        },
    };
};

const save = createDirective(pageId, true, false);
const saveHeadless = createDirective(pageId, true, true);
const print = createDirective(pageId, false, false);
const printHeadless = createDirective(pageId, false, true);

export {save, saveHeadless, print, printHeadless};
